var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"llm-edit-icon-btn",class:`llm-edit-icon-btn--${_vm.size}`,attrs:{"title":_vm.title,"role":"button","tabindex":"0"}},_vm.$listeners),[_c('EditOutlinedIcon',{attrs:{"size":_vm.iconSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }